module.exports = __webpack_public_path__ + "img/用户服务协议content.2e2484e3.png";